import React from "react";
import styles from "./footer.module.css";

const Footer = () => {
  return <div className={styles.footer}><p> تمور نخل &copy; 2026</p></div>;
};

export default Footer;
